module.exports = __webpack_public_path__ + "img/PLAINBLACK.3654ab04.png";